import { render, staticRenderFns } from "./formConfig.vue?vue&type=template&id=e35bccc4&scoped=true&"
import script from "./formConfig.vue?vue&type=script&lang=js&"
export * from "./formConfig.vue?vue&type=script&lang=js&"
import style0 from "./formConfig.vue?vue&type=style&index=0&id=e35bccc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35bccc4",
  null
  
)

export default component.exports